module.exports = __webpack_public_path__ + "img/bg-light.7fc36679.png";